<template>
  <div class="p-md">
    <div class="app-block p-md m-b-md">
      <h3 class="heading-line title is-4 has-text-weight-light">
        <span :class="'school-title-'+schoolSlug">{{ $t('candidate.messages.documents.label') }}</span>
      </h3>

      <div v-if="application.accepted && !hasAcceptedApplication()">
        <a :href="'/admissible/doc/' + application.id" :title="$t('candidate.messages.documents.accepted')">
          {{ $t('candidate.messages.documents.accepted') }}
        </a>
        <br>
        <a :href="'/cgv/' + schoolType" target="_blank" title="Conditions générales de vente">
          {{ $t('shop.messages.documents.cgv') }}
        </a>
      </div>


      <div
          v-if="application.registration && (application.registration.registration_payment_mode === 'BANK-CHECK' || application.registration.registration_payment_mode === 'BANK-DEBIT')">

        <a :href="'/inscription/doc/' + application.id" :title="$t('candidate.messages.documents.ofp')">
          {{ $t('candidate.messages.documents.ofp') }}
        </a>
      </div>

      <div v-if="application.registration && application.registration.registered_candidate">

        <a :href="'/admission/doc/' + application.id" :title="$t('candidate.messages.documents.admission')">
          {{ $t('candidate.messages.documents.admission') }}
        </a>
        <br>
        <a :href="'/certificat/doc/' + application.id" :title="$t('candidate.messages.documents.certificat')">
          {{ $t('candidate.messages.documents.certificat') }}
        </a>
      </div>

      <div
          v-if="application.registration && application.registration.registered_candidate && !application.canceled_application">
        <div class="m-t-md"
             v-if="candidate.documents && candidate.documents.scolarity && candidate.documents.scolarity.length">
          <div class="is-size-5 has-text-weight-light">Scolarité</div>

          <div v-for="document in scholarDocuments">
            <a v-if="document.path"
               :href="'/api/document_shared/'+document.path+'?token='+ token"
               target="_blank">{{ document.name }}</a>

          </div>
        </div>
      </div>
      <div class="m-t-md"
           v-if="candidate.documents && candidate.documents.trainee && candidate.documents.trainee.length">
        <div class="is-size-5 has-text-weight-light">Session</div>

        <div v-for="document in traineeDocuments">
          <a v-if="document.path"
             :href="'/api/document_shared/'+document.path+'?token='+ token"
             target="_blank">{{ document.name }}</a>

        </div>
      </div>

    </div>
  </div>

</template>

<script>
import {mapGetters} from 'vuex'
import _ from "lodash";

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      account: 'auth/getAccount'
    }),
    ...mapGetters('organization', [
      'currentScholarYear'
    ]),
    ...mapGetters({
      registeredCandidate: 'candidate/hasRegisteredApplication'
    }),
    lastApplicationLog() {
      if (!this.candidate.application_log) {
        return null;
      }

      let logs = this.candidate.application_log.filter(application => application.id !== this.application.id);

      if (logs.length === 0) {
        return null;
      }

      let orderedLogs = _.orderBy(logs, log => new Date(log.accepted_date), 'desc');

      return orderedLogs[0];
    },

    scholarDocuments() {
      let documents = []
      if (this.candidate && this.candidate.documents && this.candidate.documents.scolarity) {
        this.candidate.documents.scolarity.map(function (d) {
          if (!documents.some(doc => doc.id === d.id)) {
            documents.push(d)
          }
        })
      }
      return documents
    },
    traineeDocuments() {
      let documents = []
      if (this.candidate && this.candidate.documents && this.candidate.documents.trainee) {
        this.candidate.documents.trainee.map(function (d) {
          if (!documents.some(doc => doc.id === d.id)) {
            documents.push(d)
          }
        })
      }
      return documents
    },
    schoolType() {
      if (this.school) {
        return this.school.type
      }
    },
  },
  props: {
    school: {type: Object},
    schoolSlug: {type: String},
    candidate: {type: Object},
    application: {type: Object},
  },
  methods: {
    formatDate(date) {
      return window.moment(date.date).format('LLL');
    },
    hasAcceptedApplication() {
      return this.candidate.application_log && this.candidate.application_log.some(application => application.id !== this.application.id && application.accepted)
    },
    refusedVisaStatus(application) {
      return _.find(application.finance_status, {id: 6})
    },
    canSendCertificate() {
      return this.feesComplete() && this.feesValidated() && this.campusFranceComplete() && this.trainingRNCPComplete()
    },
    trainingRNCPComplete() {
      const training = this.application.choices[0].training
      const dates = this.application.choices[0].dates
      const training_option = this.application.choices[0].training_option

      let isValid = true
      if (!training.rncp_nb) {
        isValid = false
        this.errorRNCP = 'Numéro RNCP manquant pour la formation choisie'
      }
      if (!training_option.week_hours) {
        isValid = false
        this.errorRNCP = "Nombre d'heures par semaine manquantes pour l'option choisie"
      }
      if (!dates || (!dates.start || !dates.end)) {
        isValid = false
        this.errorRNCP = "Dates manquantes pour la formation et l'option choisie"
      }
      return isValid
    },
    campusFranceComplete() {
      return this.application && this.application.id_campus_france && this.application.email_campus_france
    },
    feesComplete() {
      return this.application
          && this.application.fees_complete
    },
    feesValidated() {
      return this.application
          && this.application.fees
    },
  }
}
</script>

<style scoped>

</style>
